export const STORAGE_KEYS = {
	TOKEN: "served:consumer:token",
	DEVICE_ID: "served:consumer:deviceId",
	CUSTOMER_TOKEN: (venueId: string) =>
		`served:consumer:customerToken:${venueId}`,
	CUSTOMER_UID: "served:consumer:customerUid",
} as const;
